import React from 'react';
import styles from './BottomLine.module.scss';

const BottomLine = () => <div className={styles.line} />;

export default BottomLine;
